import React, { FC } from 'react';

import { TeamsClientContext, TeamsClientOptions, defaultOptions } from './context';

interface TeamsClientProviderProps {
  readonly options?: TeamsClientOptions;
}

const TeamsClientProvider: FC<TeamsClientProviderProps> = ({ options = defaultOptions, children }) => (
  <TeamsClientContext.Provider value={options}>{children}</TeamsClientContext.Provider>
);

export default TeamsClientProvider;
